import {
  ARENA_CONSTANTS,
  advanceArena,
  createArenaResult,
  createArenaRun,
} from '../domain/arena-rules';

export type QaArenaScenario = 'win' | 'health' | 'time';
export type QaArenaResult = ReturnType<typeof createArenaResult> & { readonly qaOnly: true };

const QA_ARENA_SEED = 73;

export const isArenaQaEnabled = (location: Pick<Location, 'hostname' | 'search'>): boolean =>
  location.hostname === 'localhost' && new URLSearchParams(location.search).get('qa') === 'arena';

const asQaOnlyResult = (run: Parameters<typeof createArenaResult>[0]): QaArenaResult => ({
  ...createArenaResult(run),
  qaOnly: true,
});

export const createQaArenaResult = (scenario: QaArenaScenario): QaArenaResult => {
  if (scenario === 'health') {
    return asQaOnlyResult(advanceArena(createArenaRun(QA_ARENA_SEED), {
      deltaMilliseconds: 0,
      paused: false,
      forcedDamage: ARENA_CONSTANTS.startingHealth,
    }));
  }

  if (scenario === 'time') {
    return asQaOnlyResult(advanceArena(createArenaRun(QA_ARENA_SEED), {
      deltaMilliseconds: ARENA_CONSTANTS.timeCapMilliseconds,
      paused: false,
    }));
  }

  let run = advanceArena(createArenaRun(QA_ARENA_SEED), {
    deltaMilliseconds: 120_000,
    paused: false,
    teachingComplete: true,
  });
  while (run.enemies.some(({ kind }) => kind === 'elite')) {
    run = advanceArena(run, {
      deltaMilliseconds: ARENA_CONSTANTS.attackCooldownMilliseconds,
      paused: false,
      attackDirection: { x: 1, y: 0 },
      teachingComplete: true,
    });
  }
  return asQaOnlyResult(run);
};
